// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTopButton_button","visible":"ScrollToTopButton_visible","buttonToTopActive":"ScrollToTopButton_buttonToTopActive"};